module.exports = __webpack_public_path__ + "img/video5.f3d49e98.png";